/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import {
    AppBar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    TextField,
    Toolbar,
    Checkbox,
    FormControlLabel,
} from '@material-ui/core';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import React from 'react';
import { IFormularioTiposUnidadesVistaProps } from '../interfaces';
const FormularioTiposUnidadesVista: React.FunctionComponent<IFormularioTiposUnidadesVistaProps> = ({
    accionCrearEditar,
    cambiarInfoFomulario,
    cerrarFormulario,
    estadoFormulario,
    tiposUnidades,
    tipoFormulario,
}) => (
    <Dialog open={estadoFormulario}>
        <AppBar position="static">
            <Toolbar>
                <Grid container justifyContent="center">
                    <Texto
                        align="center"
                        color="inherit"
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'tiposUnidades.agregarTiposUnidades'
                                : 'tiposUnidades.modificarTiposUnidades'
                        }
                    />
                </Grid>
            </Toolbar>
        </AppBar>
        <DialogContent>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="tiposUnidades.descripcionTipoUnidad" display="inline" />}
                        inputProps={{ readOnly: tipoFormulario === TipoFormulario.Visualizacion }}
                        name="DescripcionTipoUnidad"
                        onChange={cambiarInfoFomulario}
                        required
                        value={tiposUnidades.DescripcionTipoUnidad}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={Number(tiposUnidades.Estado) === 1 ? true : false}
                                onChange={cambiarInfoFomulario}
                            />
                        }
                        label={<Texto id="productos.estado" display="inline" />}
                        name="Estado"
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            {tipoFormulario !== TipoFormulario.Visualizacion ? (
                <div>
                    <Grid container justifyContent="flex-end" spacing={2}>
                        <Grid item>
                            <Button onClick={cerrarFormulario} color="secondary" variant="contained">
                                <Texto id="boton.cancelar" />
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button onClick={accionCrearEditar} color="primary" variant="contained">
                                <Texto id="boton.guardar" />
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            ) : (
                <Button onClick={cerrarFormulario} color="secondary" variant="contained">
                    <Texto id="boton.cerrar" />
                </Button>
            )}
        </DialogActions>
    </Dialog>
);

export default FormularioTiposUnidadesVista;
